export default function FinalCTA() {
  const handleWhatsAppClick = () => {
    if (typeof window !== "undefined" && typeof (window as any).gtag_report_conversion === "function") {
      (window as any).gtag_report_conversion();
    }
    window.open(
      "https://wa.me/5512997213362?text=Ol%C3%A1%20Dr.%20Gabriel%2C%20vim%20pelo%20site%20e%20quero%20analisar%20meu%20caso%20de%20bloqueio%20judicial",
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <section
      className="relative py-24"
      style={{
        backgroundImage: `url('https://public.readdy.ai/ai/img_res/ec4b1fdef1053e399a30761cb88fb0c3.jpg')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-gray-950/92 via-gray-900/88 to-gray-950/92"></div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 bg-amber-500/15 border border-amber-500/30 text-amber-400 text-xs font-bold uppercase tracking-widest px-4 py-2 rounded-full mb-8">
          <i className="ri-time-line text-sm"></i>
          Agir rápido pode ser essencial
        </div>

        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 leading-tight">
          Teve valores bloqueados?<br />
          <span className="text-amber-400">Agir rápido pode ser essencial.</span>
        </h2>

        <p className="text-gray-300 text-base leading-relaxed mb-10 max-w-2xl mx-auto">
          Cada caso é único e merece análise técnica cuidadosa. O escritório avalia a situação de forma personalizada, sem promessas de resultado — apenas com rigor jurídico e comprometimento profissional.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={handleWhatsAppClick}
            className="inline-flex items-center gap-3 bg-amber-500 hover:bg-amber-400 text-gray-900 px-12 py-5 rounded-full text-base font-bold transition-all duration-300 cursor-pointer transform hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-search-eye-line text-lg"></i>
            QUERO ANALISAR MEU CASO
          </button>
        </div>

        <p className="text-gray-500 text-xs mt-6">
          OAB/SP 433.002 · Dr. Gabriel Araújo · (12) 99721-3362
        </p>
      </div>
    </section>
  );
}
